import Form from './CoverForm'
import isEmpty from './CoverIsEmpty'
import Section from './CoverSection'
import Thumbnail from './CoverThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
